<template>
  <div>
    <div
      id="setting-container">
      <b-row>
        <b-col cols="12">
          <b-row>
            <b-col cols="10">
              Mobile
            </b-col>
            <b-col cols="2">
              <j-toggle
                :disabled="false"
                v-model="reminder.mobile"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="10">
              Email
            </b-col>
            <b-col cols="2">
              <j-toggle
                :disabled="false"
                v-model="reminder.email"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <label>Set Reminder Before</label>
                <j-single-select
                  v-model="reminder.reminderBefore"
                  :options="options_reminder"
                  :placeholder="'Select'"
                  value-format="object"
                  label="name"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-button
            class="btn blue pull-right"
            @click="reminderConfig()">
            Apply
          </b-button>

        </b-col>

      </b-row>

    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardReminderTab',
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchQuery: '',
      onUpdate: false,

      options_reminder: [
        {
          name: '1 days',
          id: 1,
        },
        {
          name: '2 days',
          id: 2,
        },
        {
          name: '3 days',
          id: 3,
        },
        {
          name: '4 days',
          id: 4,
        },
        {
          name: '5 days',
          id: 5,
        },
        {
          name: '6 days',
          id: 6,
        },
        {
          name: '7 days',
          id: 7,
        },
      ],

      reminder: {
        mobile: false,
        email: false,
        reminderBefore: null,
      },
    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board', 'boards_updated', 'form_detail']),
  },
  watch: {

  },
  created() {
    if (this.board.notification_preference.some(el => el === 'mobile')) {
      this.reminder.mobile = true;
    }

    if (this.board.notification_preference.some(el => el === 'email')) {
      this.reminder.email = true;
    }

    this.reminder.reminderBefore = {
      id: this.board.notification_days,
      name: `${this.board.notification_days} days`,
    };
  },

  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoards', 'updateForm', 'detailForm', 'updateComponent', 'actionUpdateVisibilityPrivilege', 'actionUpdateEmailReminder']),

    reminderConfig() {
      const arrayPreference = [];
      if (this.reminder.mobile) {
        arrayPreference.push('mobile');
      }

      if (this.reminder.email) {
        arrayPreference.push('email');
      }

      const params = {
        name: this.board.name,
        notification_setting: true,
        notification_preference: arrayPreference,
        notification_days: this.reminder.reminderBefore.id,
        card_detail_base_url: `/app/${this.$route.params.applicationName}/${this.$route.params.applicationId}/${this.$route.params.pageName}/${this.$route.params.pageId}`,
      };
      this.actionUpdateEmailReminder({ boardId: this.board.id, params });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/board/tabs/jBoardReminderTab.vue